export const API_URL = "https://tanksdefense.com/api/";
